import { OpportunitiesAnalytics } from './components/OpportunitiesAnalytics';
import { OpportunitiesTable } from './components/OpportunitiesTable';

export const TABS = [
  {
    label: 'Opportunities Table',
    component: OpportunitiesTable,
    tag: 'table',
  },
  {
    label: 'Opportunities Analytics',
    component: OpportunitiesAnalytics,
    tag: 'analytics',
  },
];
